import React from 'react';
import PropTypes from 'prop-types';
import { Table, Icon, IconButton, Tooltip, Whisper } from 'rsuite';
import { includes } from 'lodash/fp';
import IconLink from '../../../IconLink';
import {
  reservationsEditPath,
  reservationsViewPath
} from '../../../../routes/Paths';
import pagePathToUrl from '../../../../helpers/pagePathToUrl';
import { COMPLETED } from '../../../../constants/reservation/Status';
import { AllowCancelStatus } from '../../../../constants/reservation/AllowActionSettings';
import {
  modifyAccess,
  fullAccess,
  viewAccess
} from '../../../../helpers/permission';
import * as PERMISSIONS from '../../../../constants/permissions/reservation';
import AccessControl from '../../../AccessControl';

const { Cell } = Table;

const ActionCell = ({
  rowData,
  dataKey,
  handleCancel,
  isSaving,
  savingId,
  ...props
}) => {
  const { id, status } = rowData;
  const isCompleted = status === COMPLETED;
  const isCanceling = isSaving && savingId === id;

  return (
    <Cell {...props} className="link-group">
      <AccessControl allowOnlyFor={modifyAccess(PERMISSIONS.MODULE)}>
        <Whisper
          placement="top"
          trigger="hover"
          speaker={<Tooltip>Edit</Tooltip>}
        >
          <IconLink
            icon="edit2"
            disabled={isCompleted || isSaving}
            to={pagePathToUrl(reservationsEditPath, { id })}
          />
        </Whisper>
      </AccessControl>

      <AccessControl allowOnlyFor={viewAccess(PERMISSIONS.MODULE)}>
        <Whisper
          placement="top"
          trigger="hover"
          speaker={<Tooltip>View</Tooltip>}
        >
          <IconLink
            icon="eye"
            to={pagePathToUrl(reservationsViewPath, { id })}
          />
        </Whisper>
      </AccessControl>

      <AccessControl allowOnlyFor={fullAccess(PERMISSIONS.MODULE)}>
        <Whisper
          placement="top"
          trigger="hover"
          speaker={<Tooltip>Cancel</Tooltip>}
        >
          <IconButton
            style={{ top: '-8px' }}
            appearance="link"
            color="red"
            onClick={() => {
              handleCancel(rowData);
            }}
            loading={isCanceling}
            disabled={isSaving || !includes(status, AllowCancelStatus)}
            icon={<Icon icon="close-circle" />}
          />
        </Whisper>
      </AccessControl>
    </Cell>
  );
};

ActionCell.propTypes = {
  rowData: PropTypes.shape({
    id: PropTypes.number,
    status: PropTypes.number
  }),
  dataKey: PropTypes.string.isRequired,
  handleCancel: PropTypes.func,
  isSaving: PropTypes.bool,
  savingId: PropTypes.number
};

ActionCell.defaultProps = {
  rowData: null,
  handleCancel: () => {},
  isSaving: false,
  savingId: null
};

export default ActionCell;
